<template>
    <h2>{{$t('partnerDetails')}}</h2>
  </template>
  
  <script>
  export default {
      name: 'ortho-partners-detail'
  }
  </script>
  
  <style>
  
  </style>
  